import { ICON__check_square_solid, ICON__square_regular } from '@/assets/icons_fa';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { use_slice_generation, use_slice_ui } from '@/hooks/store/use_slices';
import { PLACEHOLDER_BUTTON__bar } from '@/pages/_base/buttons/PLACEHOLDER_BUTTON__bar';
import { UTILS__graph_data } from '@/utils/UTILS__graph_data';
import { FIELD__ml_asset_lora } from '@shared/dto/generation/graph_invoke/_fields/ml_asset/guidance_lora/FIELD__ml_asset_lora';

interface PROPS {
  field: FIELD__ml_asset_lora;
}

export function G_BUTTON__ml_asset_lora_change_status({ field }: PROPS) {
  /*
   * STORE
   */

  const { g_general__ui_disabled } = use_slice_ui(['g_general__ui_disabled']);
  const { generation_current } = use_slice_generation(['generation_current']);

  /*
   * EVENTS
   */
  async function onClick() {
    let field_new = field.clone();
    field_new.is_enabled.invert();

    let { graph } = generation_current.tool;

    /*
     *
     */

    await UTILS__graph_data.update_field(graph, field_new);
  }

  /*
   * METHODS
   */

  function is_disabled() {
    return g_general__ui_disabled;
  }

  if (field.weight.meta.grid2d__is_dimension) return <PLACEHOLDER_BUTTON__bar />;

  /*
   * HTML
   */
  return (
    <UI_PRIMITIVE__button_with_icon_animated
      variant="no-border-on-component"
      {...{ onClick }}
      disabled={is_disabled()}
      size="rect-10-6"
      iconClassNameBase="text-component-item-foreground size-3"
      iconClassNameHovered="!text-bar-foreground"
      Icon={field.is_enabled.get_value() ? ICON__check_square_solid : ICON__square_regular}
    />
  );
}
